export default function CommunityHeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6034fd7c8b78fad23503410f710c6fc0.jpg"
          alt="Craft Community"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white">
        <h1 className="text-6xl md:text-7xl font-bold mb-8 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Craft Community
        </h1>
        <div className="w-32 h-1 bg-emerald-500 mx-auto mb-12"></div>
        <p className="text-3xl md:text-4xl font-medium leading-relaxed" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
          기술은 사람의 삶을 자립하게 합니다
        </p>
      </div>

      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white"></i>
      </div>
    </section>
  );
}